import { render, staticRenderFns } from "./el-prodGroup.vue?vue&type=template&id=08e30bcf"
import script from "./el-prodGroup.vue?vue&type=script&lang=js"
export * from "./el-prodGroup.vue?vue&type=script&lang=js"
import style0 from "./el-prodGroup.vue?vue&type=style&index=0&id=08e30bcf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports